// "Pain free" is being renamed to "Relieved" (CU-86bavpf2h), so a query for
// either value has to match both. Two reasons, with different lifetimes:
//
//   - while the backfill runs, both values are in the index, so matching only
//     one returns a partial result set that shrinks daily
//   - old ?feeling=Pain+free URLs keep arriving from bookmarks, marketing links
//     and search results long after the old value leaves the data
//
// The second reason is permanent. Do NOT delete this group when the transitional
// dual-keying is cleaned up, or those links start returning zero results.
const ALIAS_GROUPS: string[][] = [['Pain free', 'Relieved']];

export const expandFeeling = (feeling: string): string[] =>
  ALIAS_GROUPS.find((group) => group.includes(feeling)) ?? [feeling];

export const expandFeelings = (feelings: string[]): string[] => [
  ...new Set(feelings.flatMap(expandFeeling)),
];
